function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";

const CircleNotStarted = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  style: {
    width: size,
    height: size
  },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  role: title ? 'img' : 'presentation'
}), title ? /*#__PURE__*/React.createElement("title", null, title) : null, " ", /*#__PURE__*/React.createElement("path", {
  fill: color,
  d: "M10.05 2.19a10.045 10.045 0 013.9 0 .75.75 0 01-.29 1.472 8.545 8.545 0 00-3.32 0 .75.75 0 01-.29-1.472zm-2.566 1.7a.75.75 0 01-.206 1.041A8.55 8.55 0 004.93 7.278a.75.75 0 01-1.246-.835 10.05 10.05 0 012.758-2.758.75.75 0 011.04.206zm9.032 0a.75.75 0 011.04-.205c1.09.73 2.03 1.668 2.76 2.758a.75.75 0 01-1.247.835 8.55 8.55 0 00-2.347-2.347.75.75 0 01-.206-1.04zm4.412 5.569a.75.75 0 01.882.59 10.048 10.048 0 010 3.902.75.75 0 01-1.472-.291 8.544 8.544 0 000-3.32.75.75 0 01.59-.881zm-17.856 0a.75.75 0 01.59.881 8.545 8.545 0 000 3.32.75.75 0 01-1.472.29 10.045 10.045 0 010-3.9.75.75 0 01.882-.591zm.819 7.057a.75.75 0 011.04.206 8.55 8.55 0 002.347 2.347.75.75 0 11-.835 1.246 10.051 10.051 0 01-2.758-2.758.75.75 0 01.206-1.04zm16.218 0a.75.75 0 01.206 1.04 10.051 10.051 0 01-2.758 2.76.75.75 0 01-.835-1.247 8.55 8.55 0 002.347-2.347.75.75 0 011.04-.206zM9.46 20.928a.75.75 0 01.881-.59 8.544 8.544 0 003.32 0 .75.75 0 11.29 1.472 10.048 10.048 0 01-3.9 0 .75.75 0 01-.591-.882z"
}, " "));

CircleNotStarted.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,

  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,

  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default CircleNotStarted;